<template>
<div class="swiper-container">
    <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
        <!--SLIDE-1-->
        <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Créditos">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12 mt-3 d-flex justify-content-center FondoCreditos">
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12  mt-3 text-center">
                            <b-img src="recursos/img/Creditos.png" class="d-flex mx-auto mt-5" fluid alt=""></b-img>
                            <!-- <img src="../img/Creditos.png" class="img-fluid mt-5" alt=""> -->
                            <h4 class="my-5 text-left font-italic text-white"><span class="text-white">ITM Institución Universitaria </span><br>Facultad de Artes y Humanidades <br>Interpretación y Traducción Lengua de Señas Colombiana - Español </h4>
                            <div class="mb-5">
                                <!-- <p class="text-left text-white"><span class="font-weight-bold">Código del curso: </span></p> -->
                                <p class="text-left text-white"><span class="font-weight-bold">Nombre de asignatura:</span> Desarrollo Cognitivo del Sujeto Sordo</p>
                                <p class="text-left text-white"><span class="font-weight-bold">Unidad académica:</span> Desarrollo cognitivo: teoría de Piaget </p>
                                <p class="text-left text-white"><span class="font-weight-bold">Palabras claves:</span> desarrollo cognitivo, lenguaje, lengua, principios del desarrollo, sordera prelingüística, sordera poslingüística. </p>
                                <p class="text-left text-white"><span class="font-weight-bold">Fecha de creación:</span> julio de 2020</p>
                                <p class="text-left text-white"><span class="font-weight-bold">Experta en contenidos </span><br>Natalia Soto Montoya</p>
                                <p class="text-left text-white"><span class="font-weight-bold">Par evaluador</span><br>Marcel García</p>
                                <p class="text-left text-white"><span class="font-weight-bold">Asesora pedagógica </span><br>Rocío Daza Ferreira</p>
                            </div>
                        </div>
                    </div>
                    <div class=" bg-ref col-lg-6 col-md-12 col-sm-12 col-12 p-5 mt-3">
                        <div class="row d-flex justify-content-center">
                            <div class="col-lg-8 col-md-12 col-sm-12 col-12">
                                <h4 class="col-Uni3 mt-5 col03-Uni4"><span class="font-italic">Producción</span></h4> <br>
                                <p class="col-Uni3 col03-Uni4">Instituto Tecnológico Metropolitano (ITM)</p> <br>
                                <h4 class="col-Uni3 col03-Uni4"><span class="font-italic">Licencia de uso del OVA</span></h4><br>
                                <p class="col-Uni3 col03-Uni4">Este recurso digital es propiedad del Instituto Tecnológico Metropolitano (ITM) para el uso de los profesores y estudiantes adscritos a la Institución.</p>
                                <p class="col-Uni3 col03-Uni4">Este material académico puede contener, además de fuentes referenciadas, algunas relacionadas con el área de estudio que no cuentan con fechas ni autores específicos y respetan los derechos del autor, ya que se utilizan para fines educativos no comerciales y atendiendo al bien común sin causar perjuicios a los titulares.</p>
                                <p class="col-Uni3 col03-Uni4">Adicionalmente, contiene citas textuales de más de 40 palabras, que, para observarlas en su forma original y de manera correcta según las Normas APA, deberán ser consultadas en la versión imprimible de este objeto virtual de aprendizaje.</p>
                                <p class="col-Uni3 col03-Uni4">Las imágenes de apoyo utilizadas en este material son de uso libre, por lo tanto si los autores deciden eliminarlas, es probable que no estén en internet en el momento de consulta.</p>
                            </div>
                        </div>
                        <br>
                        <div class="row d-flex justify-content-center text mb-5">
                            <div class="col-12 col-lg-4 col-md-12 col-sm-12 mb-5">
                                <h4>Creado por:</h4>
                                <b-img src="recursos/img/itm-logo.png" class="d-flex mx-auto" fluid alt=""></b-img>
                            </div>
                            <div class="col-12 col-lg-4 col-md-12 col-sm-12 text-center">
                                <h4 class="col03-Uni4">Atribución - No comercial - Sin derivar</h4>
                                <b-img src="recursos/img/cc-info.png" class="d-flex mx-auto" fluid alt=""></b-img>
                                <p class="col-Uni3 col03-Uni4"><span class="font-italic">Esta licencia permite a otros distribuir, remezclar, retocar, y crear a partir de tu obra de modo no comercial, siempre y cuando te den crédito y licencien sus nuevas creaciones bajo las mismas condiciones.</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--SLIDE-1-->
    </div>
</div>
</template>

<script>
import {
    SwiperController
} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'Créditos',
    mounted() {
        SwiperController(),
            document.title = this.$route.meta.title
    }
};
</script>
